import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  Cluster: {
    icon: 'clusters',
    to: 'ClusterListUI',
  },
  ClusterByUserDiagnostic: {
    icon: 'stethoscope',
    to: 'NDiagClustersByUserVerificationUI',
  },
  CustomUIViewListUI: {
    icon: 'createCustomView',
    to: 'CustomUIViewListUI',
  },
  DatabaseMigration: {
    to: 'DatabaseMigrationUI',
  },
  DatabaseServer: {
    icon: 'database',
    to: 'DataBaseServerListUI',
  },
  DeploymentDashboard: {
    icon: 'connectivity',
    to: 'DeploymentUI',
  },
  NeosDataImport: {
    to: 'NeosDataImportTemplateEditUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  RolesAndPermissions: {
    icon: 'roleUsers',
    to: 'AssignPermissionToRolesListUI',
  },
  Tenant: {
    icon: 'multiTenant',
    to: 'TenantListUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserList: {
    icon: 'user',
    to: 'UserAccountListUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  }
}